import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['link', 'customerMessage', 'networkMessage']

  updateLink(event) {
    const url = event.target.dataset.url
    const value = event.target.value

    if (url && this.hasLinkTarget) {
      this.linkTarget.href = url
      if (value === 'network') {
        this.linkTarget.setAttribute('target', '_blank')
        this.linkTarget.setAttribute('rel', 'noopener noreferrer')
      } else {
        this.linkTarget.removeAttribute('target')
        this.linkTarget.removeAttribute('rel')
      }
    }

    this.#toggleMessages(value)
  }

  #toggleMessages(profileType) {
    const types = ['customer', 'network']

    types.forEach(type => {
      const target = this[`${type}MessageTarget`]
      target.classList.toggle('d-none', type !== profileType)
    })
  }
}
